import React from "react";
import { useState } from "react";
import { CloseIcon } from "../../helper/icon";
import "./BankInformation.css";

const BankInformation = ({ user }) => {
  const bankList = [
    "GTBank",
    "First Bank",
    "Access Bank",
    "Zenith Bank",
    "UBA",
  ];

  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountName, setAccountName] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [bankDetails, setBankDetails] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    if (!bankName) {
      newErrors.bankName = "Bank name is required";
    }

    if (!accountNumber) {
      newErrors.accountNumber = "Account number is required";
    } else if (!/^\d{10}$/.test(accountNumber)) {
      newErrors.accountNumber = "Account number must be 10 digits";
    }

    if (!accountName) {
      newErrors.accountName = "Account name is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      const isSuccess = Math.random() > 0.3;

      if (isSuccess) {
        setBankDetails({
          bankName,
          accountNumber,
          accountName,
        });
        // Reset form
        setBankName("");
        setAccountNumber("");
        setAccountName("");
        setShowSuccessModal(true);
      } else {
        setShowErrorModal(true);
      }
    }, 1500);
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
  };

  const handleErrorModalClose = () => {
    setShowErrorModal(false);
  };

  const handleTryAgain = () => {
    setShowErrorModal(false);
  };

  const SuccessModal = () => (
    <div className="modal-overlay" onClick={handleSuccessModalClose}>
      <div
        className="modal-content success-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="modal-close" onClick={handleSuccessModalClose}>
          <CloseIcon />
        </button>
        <div className="modal-icon success-icon">
          <img src="/images/approved.png" alt="Logout" />
        </div>
        <h3 className="modal-title">Bank Information Updated</h3>
        <p className="modal-message">
          You have successfully updated your bank account information.
        </p>
        <button
          className="modal-button success-button"
          onClick={handleSuccessModalClose}
        >
          Dismiss
        </button>
      </div>
    </div>
  );

  const ErrorModal = () => (
    <div className="modal-overlay" onClick={handleErrorModalClose}>
      <div
        className="modal-content error-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="modal-close" onClick={handleErrorModalClose}>
          <CloseIcon />
        </button>
        <div className="modal-icon error-icon">
          <img src="/images/failed.png" alt="Logout" />
        </div>
        <h3 className="modal-title">Failed</h3>
        <p className="modal-message">
          Your bank details update failed, try again!!!
        </p>
        <div className="modal-buttons">
          <button
            className="modal-button close-button"
            onClick={handleErrorModalClose}
          >
            Close
          </button>
          <button
            className="modal-button try-again-button"
            onClick={handleTryAgain}
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="bank-information">
      <h2>{bankDetails ? "Bank Information" : "Add Bank Information"}</h2>
      <p className="bank-info-description">
        Make sure your bank account name matches your registered name on the App
      </p>

      {bankDetails ? (
        <div className="bank-details">
          <div className="bank-icon">
            <span>🏦</span>
          </div>
          <div className="bank-info">
            <div className="info-item">
              <label>Bank Name:</label>
              <p>{bankDetails.bankName}</p>
            </div>
            <div className="info-item">
              <label>Account Number:</label>
              <p>{bankDetails.accountNumber}</p>
            </div>
            <div className="info-item">
              <label>Account Name:</label>
              <p>{bankDetails.accountName}</p>
            </div>
          </div>
          <button
            className="edit-bank-button"
            onClick={() => setBankDetails(null)}
          >
            Edit
          </button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="bank-form">
          <div className="bank-information-group">
            <label htmlFor="bankName">Bank</label>
            <select
              id="bankName"
              value={bankName}
              onChange={(e) => setBankName(e.target.value)}
              className={errors.bankName ? "error" : ""}
            >
              <option value="">Type/Select Bank</option>
              {bankList.map((bank, index) => (
                <option key={index} value={bank}>
                  {bank}
                </option>
              ))}
            </select>
            {errors.bankName && (
              <p className="error-message">{errors.bankName}</p>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="accountNumber">Account Number</label>
            <input
              type="text"
              id="accountNumber"
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
              placeholder="Enter Account Number"
              className={errors.accountNumber ? "error" : ""}
              maxLength={10}
            />
            {errors.accountNumber && (
              <p className="error-message">{errors.accountNumber}</p>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="accountName">Account Name</label>
            <input
              type="text"
              id="accountName"
              value={accountName}
              onChange={(e) => setAccountName(e.target.value)}
              placeholder="Enter Account Name"
              className={errors.accountName ? "error" : ""}
            />
            {errors.accountName && (
              <p className="error-message">{errors.accountName}</p>
            )}
          </div>

          <div className="form-actions">
            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      )}

      {bankDetails && (
        <div className="user-info">
          <p className="user-name">{`${user?.firstName || ""} ${
            user?.lastName || ""
          }`}</p>
          <p className="user-phone">{user?.phoneNumber || ""}</p>
        </div>
      )}

      {showSuccessModal && <SuccessModal />}
      {showErrorModal && <ErrorModal />}
    </div>
  );
};

export default BankInformation;
